module.exports = __webpack_public_path__ + "static/img/sl-4.1bee45e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/sl-4.png
// module id = 9oYq
// module chunks = 0